/* ================================================================
 * Copyright © 2025 Tobeunicorn Co., Ltd. All rights reserved.
 *
 * 프로젝트명 : ArmyLink V1.0
 * 설명 : 캘린더 상태 선택 박스
 * 버전 : 1.0
 * 파일명 : RecruitSelectStatus.tsx
 * 작성자 : 강동형
 * 작성일 : 2025-03-01
 * ================================================================
 * 수정 : 2026-02-04, 강동형 : 탭 변경시 초기화 로직 추가
 *================================================================*/

import { Select, SelectChangeEvent, MenuItem } from '@mui/material'
import { useEffect, useState } from 'react'
import { useRecruitStore } from 'src/stores/RecruitStore';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';

const menuProps = {
    PaperProps: {
        sx: {
          maxHeight: '200px',
          overflowY: 'auto',
          border: '1px solid #508A9C',
          paddingY :0,
          '& .MuiMenu-list': {
            paddingTop: 0,
            paddingBottom: 0,
      },
        },
      },
      TransitionProps: {
        onEntering: (menuElement: HTMLElement) => {
          menuElement.scrollTop = 0;
        },
      },
}

const sx = {
    height:'46px',
    minWidth: '102px',
    textAlign:'center',
    justifyContent:'center',
    border: '1.5px solid #508A9C',
    '&.Mui-selected': {
      backgroundColor: '#EEF6F8',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    // '& svg': {
    //   right: '30%',
    //   transform: 'translateX(50%)',
    //   position: 'absolute',
    //   pointerEvents: 'none',
    // },
}

const DropBoxSx = {
    // justifyContent: 'center',
    // textAlign: 'center',
    height:'46px',
    borderTop : '1.5px solid #508A9C'
}

type RecruitSelectStatusProps = {
  whichTab:'모집 일정' | '축제 정보'
}

const RecruitSelectStatus = ({whichTab}:RecruitSelectStatusProps) => {
    const typeContent = whichTab === '모집 일정' ? ['상태','모집 예정','모집 중','선발 중','선발 완료'] : ['상태','진행 전','진행 중','진행 완료']
    const [type,setType] = useState('상태');
    const setField = useRecruitStore((state)=>state.setField)
    const reset = useRecruitStore((state)=>state.reset)

    useEffect(()=>{
      reset('status')
    },[whichTab])

    const handleTypeChange = (e:SelectChangeEvent<string>)=>{
        setType(e.target.value)
        setField('status',e.target.value)
    }

  return (
      <Select
          value={type}
          onChange={handleTypeChange}
          renderValue={(selected) => `${selected}`}
          MenuProps={menuProps}
          sx={sx}
          IconComponent={KeyboardArrowDown}
          >
          {typeContent.map((content, index) => (
              <MenuItem value={content.toString()} sx={DropBoxSx} key={index}>
                  {content}
              </MenuItem>
          ))}
      </Select>
  )
}

export default RecruitSelectStatus